import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import SubmitButton from '../_shared/SubmitButton';

class CreateJobByType extends Component {
    constructor(props) {
        super(props);

        const el = document.getElementById('create-job-by-type');
        const jobTypes = JSON.parse(el.dataset.jobTypes || '[]');

        // Filter job types to only allowed IDs
        const allowedIds = [6, 16, 17, 18, 28];
        const filteredJobTypes = jobTypes.filter(jt => allowedIds.includes(jt.id));

        const selectedJobType = filteredJobTypes.length > 0 ? filteredJobTypes[0].id : '';

        this.state = {
            jobTypes: filteredJobTypes,
            selectedJobType,
            loading: false,
            jobId: null,
        };
    }

    handleJobTypeChange = (e) => {
        this.setState({ selectedJobType: parseInt(e.target.value, 10) });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Creating job with fixed customer/contact/date/by values');

        const { selectedJobType } = this.state;
        if (!selectedJobType) return;

        this.setState({ loading: true, jobId: null });

        try {
            const token = localStorage.getItem('testing_app_token');

            const response = await axios.post(this.props.url, {
                customer_id: 473,
                customer_contact_id: 2276,    
                job_type_id: selectedJobType,
                date_ready: new Date().toISOString().split('T')[0], // today
                created_by: 'test script'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            this.setState({ jobId: response.data.job_id });
            toastr.success('Job created successfully!');
        } catch (err) {
            console.error('Failed to create job:', err);
            toastr.error('Failed to create job');
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const { jobTypes, selectedJobType, loading, jobId } = this.state;

        return (
            <form onSubmit={this.handleSubmit}>
                <h4>Create Job</h4>

                <div className="form-group">
                    <label>Job Type</label>
                    <select
                        className="form-control"
                        value={selectedJobType}
                        onChange={this.handleJobTypeChange}
                    >
                        {jobTypes.map(jt => (
                            <option key={jt.id} value={jt.id}>{jt.name}</option>
                        ))}
                    </select>
                </div>

                <SubmitButton
                    buttonText="Create Job"
                    loading={loading}
                />

                {jobId && <p>Job successfully created! ID: {jobId}</p>}
            </form>
        );
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const el = document.getElementById('create-job-by-type');
    if (el) {
        const jobTypes = JSON.parse(el.dataset.jobTypes || '[]');

        ReactDOM.render(
            <CreateJobByType
                url={el.dataset.url}
                jobTypes={jobTypes}
            />,
            el
        );
    }
});

export default CreateJobByType;
